const env = process.env.NODE_ENV
export const API_BASE = process.env.VUE_APP_BASE_URL

export const BASE_PATH = process.env.VUE_APP_BASE_PATH

export const PY_API = process.env.VUE_APP_PY_UTL + "/"

// export const API_BASE = {
//   test: "",
//   development: "http://192.168.31.51:10013/rencai/api/",
//   production: "https://reward.wenzhou.gov.cn/rencai/api/"
// }

// const ENV_PATH = {
//   test: "",
//   development: "",
//   production: ""
// }

export const LOGIN_CHANNEL = "mobile"
export const ID_TOKEN_KEY = "talentmobilerefact_id_token"
export const ID_KEY = "alumni_id"
export const RC_ID_KEY = "alumni_rc_id"

export const API_URL = API_BASE + BASE_PATH

export const BASE_URL = API_BASE[env]

export const useMock = false

export const MOCK_API = ""
export const mockURL = MOCK_API

export const TOKEN_PREFIX = "Bearer"

export default API_URL

export const isNew = true
